<script setup>
defineProps({
  title: {
    type: String,
    default: 'Каталог',
  },
  showDesktop: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['close', 'search']);
</script>
<template>
  <div class="catalog-header" :class="{ showDesktop: showDesktop }">
    <div class="close icon" @click="emit('close')">
      <img class="icon" src="/static/images/arrow-left.svg" alt="назад" />
    </div>
    <span class="title">{{ title }}</span>
    <div class="icon" @click="emit('search')">
      <UiIcon name="search" size="16" stroke="#86888F" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.catalog-header {
  display: grid;
  grid-template-columns: repeat(3, max-content);
  grid-gap: 10px;
  justify-content: space-between;
  align-items: center;
  background: $white;
  box-shadow: 0 2px 4px rgba(148, 148, 148, 0.12);
  height: 52px;
  @include fz(14, 20, 500);
  padding: 12px;
  z-index: 2;
  position: relative;
  @include xl-block {
    display: none;
    > div,
    div.icon {
      display: none;
    }
  }

  .close {
    cursor: pointer;
  }

  .title {
    font-weight: 700;
    max-width: 236px;
    @media screen and (min-width: 403px) {
      max-width: 100%;
    }
  }

  &.showDesktop {
    @include xl-block {
      display: grid;
      padding: 0;
      height: auto;
      box-shadow: none;
      align-items: start;
      grid-template-columns: 1fr;
    }

    .title {
      @include xl-block {
        display: grid;
        @include fz(26, 36, 700);
        text-transform: uppercase;
        color: #242424;
        width: 100%;
        margin: 24px 0 16px;
      }
    }
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
  }
}
</style>
